import Reviews from "../../assets/icons/reviews.svg";
import { Card } from "antd";
import { Link } from "react-router-dom";
import Rate from "../common/rate";

const ProfileRatingCard = ({ type, email, phone, data }) => {
  if (type === "emailphone") {
    return (
      <Card className="border-2 shadow-md border-gray-200 sm:w-54.1  bg-white">
        <div className="grid sm:grid-cols-2 sm:space-x-8 sm:justify-start justify-center break-all">
          <div className="flex ml-0 sm:ml-1.5 mt-1">
            <div className="flex sm:items-start items-center flex-col">
              <p className="font-medium text-primaryPurple text-lg mb-0">
                Email
              </p>
              <p className="font-medium mt-0">{email}</p>
            </div>
          </div>
          <div className="flex sm:items-start items-center flex-col mt-1 mr-1.5">
            <p className="font-medium text-primaryPurple text-lg mb-0">
              Phone Number
            </p>
            <p className="font-medium mt-0">{phone}</p>
          </div>
        </div>
      </Card>
    );
  } else if (type === "reviews") {
    return (
      <Card className="border-2 shadow-md border-gray-200 sm:w-54.1 sm:h-11.7">
        <div className="flex justify-start ml-2">
          <img src={Reviews} alt="Review Icon" className="mr-1" />
          <p className="font-bold text-primaryOrange">Total Reviews</p>
        </div>
        <div className="flex items-center p-1">
          <p className="text-2xl m-1">{data?.averageRating?.toFixed(1) ?? 0}</p>
          <Rate
            value={Math.round(data?.averageRating) ?? 0}
            disabled={"disabled"}
          />
          <div className="flex items-center justify-end flex-1">
            <Link
              to="/main/profile/reviews"
              className="font-medium text-primaryPurple underline hover:underline hover:text-primaryPurple"
            >
              {data?.count ?? 0} reviews
            </Link>
          </div>
        </div>
      </Card>
    );
  }
};

export default ProfileRatingCard;
